import Auth from '@aws-amplify/auth';

const PACKAGE_WARNINGS_TO_SUPPRESS = [
  {
    package: '@amzn/meridian',
    messageIncludes: 'Support for defaultProps will be removed',
  },
];

/**
 * This to run before react loads
 */
export function Init(): void {
  // The meridian error about `defaultProps` was flooding my browser's console
  // output so I was missing other errors
  // eslint-disable-next-line no-process-env
  if (process.env.NODE_ENV === 'development') {
    const originalError = console.error;
    console.error = (...args) => {
      for (const warning of PACKAGE_WARNINGS_TO_SUPPRESS) {
        if (
          typeof args[0] === 'string' &&
          args[0].includes(warning.messageIncludes) &&
          typeof args[2] === 'string' &&
          args[2].includes(`node_modules/${warning.package}/`)
        ) {
          return;
        }
      }
      originalError(...args);
    };
  }
  // Setup Authentication
  Auth.configure({
    stage: 'prod',
    aws_cognito_region: 'us-east-1',
    aws_cognito_identity_pool_id: 'us-east-1:9244f425-61c9-4b35-a387-178ce27a700d',
    aws_user_pools_id: 'us-east-1_dIRvgsrfz',
    aws_user_pools_web_client_id: '61nrdvjd27416k3njufj1q7osq',
    Auth: {
      identityPoolId: 'us-east-1:9244f425-61c9-4b35-a387-178ce27a700d',
      region: 'us-east-1',
      userPoolId: 'us-east-1_dIRvgsrfz',
      userPoolWebClientId: '61nrdvjd27416k3njufj1q7osq',
    },
    oauth: {
      domain: `rtw-tool-prod-na.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: 'https://prod.na.rtw.whs.amazon.dev',
      redirectSignOut: 'https://prod.na.rtw.whs.amazon.dev',
      scope: ['openid', 'profile'],
      responseType: 'code',
    },
  });
}
